import { useSelector } from 'react-redux';
import { DecorativeModal as BeamDecorativeModal, IRawDecorativeModalProps } from '@vst/beam';

import { selectConfig } from '@app/redux/config';

import { Platform } from '@mfe/shared/schema-types';

import styles from './styles.module.scss';

type DecorativeModalProps = Omit<IRawDecorativeModalProps, 'ref'>;

export const CustomDecorativeModal = (props: DecorativeModalProps) => {
  const { platform } = useSelector(selectConfig);

  const defaultClassName = props.surfaceProps?.className ?? '';
  // mobileModal ensures the CTAs are visible alongside the mobile bottom navbar
  const mobileModalClassName = `${styles['mobileModal']}`;
  // buttonOverwrite ensures the CTAs don't have fixed width
  const actionsClassName = `${styles['buttonOverwrite']}`;

  const desktopClassName = `${defaultClassName} ${actionsClassName}`;
  const mobileClassName = `${defaultClassName} ${mobileModalClassName} ${actionsClassName}`;

  return platform === Platform.Web ? (
    <BeamDecorativeModal {...props} surfaceProps={{ className: desktopClassName }} />
  ) : (
    <BeamDecorativeModal {...props} surfaceProps={{ className: mobileClassName }} />
  );
};
